import React from 'react';
import { Box, Card, CardContent, CardHeader } from '@mui/material';
import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { jsonFormsColumns } from '../../services/column-definitions';
import JsonFormUpdateCreate from './JsonFormUpdateCreate';
import JsonFormNewVersion from './JsonFormNewVersion';
import Scrollbar from '../Scrollbar';

export default function JsonFormsList({ forms, setForms }) {
  const [form, setForm] = React.useState({});
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [openNewVersionModal, setOpenNewVersionModal] = React.useState(false);

  const handleOpenEditModal = row => {
    setForm(row);
    setOpenEditModal(true);
  };

  const handleOpenNewVersionModal = row => {
    setForm(row);
    setOpenNewVersionModal(true);
  };

  return (
    <Scrollbar>
      <Box sx={{ minWidth: { md: 800 }, m: 4 }}>
        <Card>
          <CardHeader title="Formularze JSON" />
          <CardContent>
            <DataGridPro
              columns={jsonFormsColumns(handleOpenEditModal, handleOpenNewVersionModal)}
              rows={forms}
              density="standard"
              disableColumnMenu={true}
              autoPageSize={false}
              autoHeight={true}
              rowsPerPageOptions={[10, 25, 50, 100]}
              pagination
              localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
              disableSelectionOnClick
            />
          </CardContent>
        </Card>
      </Box>
      {openEditModal ? <JsonFormUpdateCreate open={openEditModal} setOpen={setOpenEditModal} form={form} setForms={setForms}/> : null}
      {openNewVersionModal ? <JsonFormNewVersion open={openNewVersionModal} setOpen={setOpenNewVersionModal} form={form} forms={forms} setForms={setForms}/> : null}
    </Scrollbar>
  );
};
